import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import AddFundPaymentModal from './AddFundPaymentModal'; 

const AddFund = ({ UserId, UserName }) => {
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const handleSubscribeClick = () => {
    document.body.classList.add('show-payment-modal'); // Add class to body
    setShowPaymentModal(true); // Open payment modal on button click
  };

  return (
    <>
      <div className="add_funds_wrap">
        <Link className="subscription_btn center-text" onClick={handleSubscribeClick}>
          <span>Add Credits</span>
        </Link>
      </div>

      {showPaymentModal && (
        <AddFundPaymentModal
          onClose={() => setShowPaymentModal(false)}
        />
      )}

    </>
  );
};

export default AddFund;
